export default __webpack_public_path__ + "static/media/fig-07b-face-log-2.4e8f08bc.jpg";